import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AdminModal from '../common/AdminModal';
import { fetchWithAuth } from '../../auth/fetchWithAuth';
import { API_URL } from '../../../config/env';

export default function DeactivateUserModal({ show, onClose, user, action, onCompleted }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const isDeactivate = action === 'deactivate';
  const endpointAction = isDeactivate ? 'deactivate' : 'reactivate';

  const handleSubmit = async () => {
    if (!user) return;
    setSubmitting(true);
    setError(null);
    try {
      const res = await fetchWithAuth(`${API_URL}/v1/admin/users/${user.id}/${endpointAction}`, {
        method: 'POST',
      });
      const payload = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(payload.error || payload.errors?.join(', ') || `Failed to ${endpointAction} user`);
      }
      onCompleted(payload);
      onClose();
    } catch (e) {
      setError(e.message || `Failed to ${endpointAction} user`);
    } finally {
      setSubmitting(false);
    }
  };

  const footer = (
    <div className="d-flex justify-content-between w-100">
      <button type="button" className="btn btn-link text-muted" onClick={onClose} disabled={submitting}>
        <i className="bi bi-arrow-left me-1" /> Cancel
      </button>
      <button
        type="button"
        className={`btn ${isDeactivate ? 'btn-danger' : 'btn-primary'}`}
        onClick={handleSubmit}
        disabled={submitting || !user}
      >
        {isDeactivate ? 'Deactivate user' : 'Reactivate user'}
      </button>
    </div>
  );

  return (
    <AdminModal
      show={show}
      onClose={onClose}
      title={isDeactivate ? 'Deactivate User' : 'Reactivate User'}
      footer={footer}
      size="sm"
    >
      {!user ? null : (
        <>
          <p className="mb-2">
            {isDeactivate
              ? 'This user will be signed out and will no longer be able to log in.'
              : 'This user will be able to log in again.'}
          </p>
          <div className="small text-muted">User</div>
          <div className="fw-semibold mb-2">{user.email}</div>
          {error && <div className="alert alert-danger py-2 mb-0">{error}</div>}
        </>
      )}
    </AdminModal>
  );
}

DeactivateUserModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object,
  action: PropTypes.oneOf(['deactivate', 'reactivate']),
  onCompleted: PropTypes.func,
};

DeactivateUserModal.defaultProps = {
  user: null,
  action: 'deactivate',
  onCompleted: () => {},
};
